const playStore = ()=>{
    //是否模拟登录
    const isMoniLogin = ref(false)
    const setIsMoniLogin = (v)=>{
        isMoniLogin.value = v
    }
    return {
        isMoniLogin,
        setIsMoniLogin
    }
}

export const usePlayStore = defineStore('playStore', playStore, { persist:{
    enabled:true,
    storage:sessionStorage
}})